<style scoped lang="scss">

</style>

<template>
    <div class="uk-grid" >
        <div class="uk-width-1-1 uk-margin-bottom" v-if="showPerson">
            <autocomplete
                    :placeholder="'Find Person or Company...'"
                    ref="autocompleteAdddressForm"
                    class="form-autocomplete"
                    :search="search"
                    :get-result-value="getResultValue"
                    :debounce-time="200"
                    @submit="setPerson"
            >
            </autocomplete>
        </div>
        <div class="uk-width-1-1 uk-margin-bottom" v-if="showPerson">
            <input type="text" class="uk-width-1-1 uk-form-large" v-model="organization.organization_name" placeholder="Company Name">
        </div>

        <div class="uk-width-1-2 uk-margin-bottom" v-if="showPerson">
            <input type="text" class="uk-width-1-1 uk-form-large" v-model="person.first_name" placeholder="First Name">
        </div>
        <div class="uk-width-1-2 uk-margin-bottom" v-if="showPerson">
            <input type="text" class="uk-width-1-1 uk-form-large" v-model="person.last_name" placeholder="Last Name">
        </div>

        <div class="uk-width-1-1 uk-margin-bottom" v-if="showPerson">
            <input type="text" class="uk-width-1-1 uk-form-large" v-model="person.email" placeholder="Email Address">
        </div>
        <div class="uk-width-1-1 uk-margin-bottom" v-if="showPerson || showPhone">
            <phone-number-input
                    name="Property Manager Phone"
                    v-model="person.phone"
                    @onValidated="$emit('phoneUpdated', $event)"
            ></phone-number-input>
        </div>
        <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 ">
            <TextInput
                    v-model="address.line_1"
                    name="Line1"
                    placeholder="Street Address"
                    rules="required"
                    @input="update"
            />
        </div>
        <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
            <TextInput
                    v-model="address.line_2"
                    :name="lineTwoLabel"
                    :placeholder="lineTwoLabel"
                    @input="update"
            />
        </div>
        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
            <TextInput
                    v-model="address.city"
                    name="City"
                    placeholder="City"
                    rules="required"
                    @input="update"
            />
        </div>
        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
            <select v-model="address.state_id" class="uk-width-1-1 state-select uk-button uk-form-select uk-form-large">
                <option :value="null" selected>_</option>
                <option v-for="item in assets.states" :value="item.id" :key="item.id">{{item.state_name}}</option>
            </select>
        </div>
        <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
            <TextInput
                    v-model="address.zip"
                    name="Zip"
                    placeholder="Zip"
                    rules="required"
                    @input="update"
            />
        </div>

        <!-- Choose Company Modal -->
        <select-organization-modal
                @select="setOrganizationFromModal"
                ref="organizationModal"></select-organization-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import SelectOrganizationModal from "./SelectOrganizationModal";
    export default {
        name: "AddressForm",
        components: {
            SelectOrganizationModal,
            Autocomplete,
        },
        props: {
            person: {
                type: Object,
                default: () => {
                    return {}
                },
            },
            organization: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            showPerson: {
                type: Boolean,
                default: true,
            },
            showPhone: {
                type: Boolean,
                default: false,
            },
            nameText: {
                type: String,
                default: 'Name'
            },
            lineTwoLabel: {
                type: String,
                default: 'Address Line 2'
            },
            address: {
                type: Object,
                sync: true,
                default: () => {
                    return {
                        line_1: '',
                        line_2: '',
                        city: '',
                        state: '',
                        state_id: null,
                        zip: '',
                    }
                }
            }
        },
        computed: {
            ...mapState('Application', {
                assets: state => state.assets,
                applicant: state => state.applicant,
                application: state => state.application,
                renterOwner: state => state.renterOwner,
                renterManager: state => state.renterManager,
            })
        },
        methods: {
            update() {
                this.$emit('update', this.address);
            },
            async search(query) {
                if(query.length < 3) return [];
                // Search People
                let url = '/api/hope/applications/'+this.applicationId+'/find-landlord';
                let r = await axios.get(url+'?query='+query);
                r.data.push({
                    id: null,
                    first_name: 'Add New',
                    last_name: 'Contact',
                })
                return r.data;
            },
            getResultValue(result) {
                let stringParts = [result.first_name + ' ' + result.last_name];

                stringParts.push(result.organization_name);

                return stringParts.join(' | ')
            },
            setPerson(result) {
                console.log('setting person', result);
                if(result && result.address) {
                    this.$emit('update', result.address);
                }

                this.$emit('organizationUpdated', {
                    id: result.org_id,
                    organization_name: result.organization_name,
                });

                this.$emit('personUpdated', result);
            },

            setOrganizationFromModal(organization) {
                this.$emit('organizationUpdated', organization);
                // Close Modal
            }
        }
    }
</script>
